/* eslint-disable jsx-a11y/anchor-is-valid */ import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ChevronRight } from "../../../assets/chevron-right";
import { ChevronLeft } from "../../../assets/chevron-left";
import { ChevronDown } from "../../../assets/chevron-down";
import styles from "./nav-item.module.css";
import cx from "classnames";
import { ChevronUp } from "../../../assets/chevron-up";
export var NavItem = function(param) {
    var _activeMenu = param.activeMenu, activeMenu = _activeMenu === void 0 ? null : _activeMenu, handleItemSelection = param.handleItemSelection, handleTrackEvent = param.handleTrackEvent, title = param.title, href = param.href, children = param.children;
    var handleNavItemClick = function(e) {
        var selectedMenuTarget = e.currentTarget;
        var id = selectedMenuTarget.id;
        if (hasChildren) {
            e.preventDefault();
        }
        handleItemSelection && handleItemSelection(id);
        handleTrackEvent && handleTrackEvent();
    };
    var hasChildren = children ? true : false;
    var anchorProps = {
        href: href
    };
    if (hasChildren) {
        anchorProps["aria-expanded"] = activeMenu ? true : false;
        anchorProps["href"] = "#";
    }
    var isMobileAriaLabel = "object" !== "undefined" && window.innerWidth < 768;
    var _obj;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({
                "aria-label": isMobileAriaLabel ? "".concat(title, " mobile") : title,
                id: title,
                className: cx(styles.navItemContainer, (_obj = {}, _define_property(_obj, styles.navItemContainerActive, activeMenu === title), _define_property(_obj, styles.secondaryNavItemContainer, hasChildren), _obj)),
                onClick: function(e) {
                    handleNavItemClick(e);
                }
            }, anchorProps), {
                children: [
                    hasChildren && activeMenu && /*#__PURE__*/ _jsx("div", {
                        className: styles.mobileChevron,
                        children: /*#__PURE__*/ _jsx(ChevronLeft, {})
                    }),
                    title,
                    hasChildren && !activeMenu && /*#__PURE__*/ _jsx("div", {
                        className: cx(styles.mobileChevron, styles.mobileChevronRight),
                        children: /*#__PURE__*/ _jsx(ChevronRight, {})
                    }),
                    hasChildren && /*#__PURE__*/ _jsx("div", {
                        className: styles.desktopChevron,
                        children: activeMenu === title ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {})
                    })
                ]
            })),
            activeMenu === title && children
        ]
    });
};
